module.exports = __webpack_public_path__ + "media/images/emblems/Le_Noirmont-e6904354539b3b1147f707ad7581fc3e.png";